
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/subscribe/thank-you",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/subscribe/thank-you.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/subscribe/thank-you"])
      });
    }
  